import { render, staticRenderFns } from "./SemenReceiptStorageAdd.vue?vue&type=template&id=7dbffde3&scoped=true&"
import script from "./SemenReceiptStorageAdd.vue?vue&type=script&lang=js&"
export * from "./SemenReceiptStorageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbffde3",
  null
  
)

export default component.exports